function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 15 15"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M9.375 7.5a2.5 2.5 0 10.001-4.999A2.5 2.5 0 009.375 7.5zM3.75 6.25V4.375H2.5V6.25H.625V7.5H2.5v1.875h1.25V7.5h1.875V6.25H3.75zm.625 5c0-1.662 3.331-2.5 5-2.5s5 .838 5 2.5v1.25h-10v-1.25z",
  fill: "currentColor"
})));